module.exports = __webpack_public_path__ + "static/media/main idea.dd355b1d.mp3";